package pl.nickers.match3

actual fun currentTimeMillis(): Long = kotlin.js.Date.now().toLong()
